import { connect } from 'react-redux'
import ReportHeader from 'components/ReportHeader'
import { selectPlant } from 'reports/scrapTrend/selectors'

const mapStateToProps = state => ({
  name: selectPlant(state).name
})

export default connect(mapStateToProps)(ReportHeader)
